<template>
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M26.0392 6.16774C26.0392 6.16774 28.1668 5.34531 27.9895 7.34264C27.9304 8.16508 27.3985 11.0436 26.9848 14.1571L25.5664 23.38C25.5664 23.38 25.4482 24.7312 24.3843 24.9662C23.3205 25.2011 21.7247 24.1437 21.4292 23.9087C21.1928 23.7325 16.9966 21.089 15.519 19.7966C15.1053 19.4441 14.6325 18.7392 15.5781 17.9167L21.7838 12.0423C22.4931 11.3373 23.2023 9.69246 20.2472 11.6898L11.9729 17.2706C11.9729 17.2706 11.0273 17.858 9.25425 17.3293L5.4126 16.1544C5.4126 16.1544 3.99415 15.2732 6.41734 14.392C12.3275 11.631 19.5971 8.81124 26.0392 6.16774Z" fill="white"/>
	</svg>
</template>



	